import { IMPORT_CREATE_REQUEST } from "./index";

export const createImport = (token, shipments) => ({
  type: IMPORT_CREATE_REQUEST,
  payload: {
    token,
    shipments
  }
});
